import { IMZACILARI_LISTELE } from "../constants/requestUrls";
import { getRequest } from "../request";

const getImzacilarListByDosyaKodu = (dosyaKodu) => {
    return getRequest({ url: IMZACILARI_LISTELE + "?dosyaKodu=" + dosyaKodu });
}

export default getImzacilarListByDosyaKodu;